const values = state => state.values
const selected = state => state.selected
const questions = state => state.questions
const reloading = state => state.reloading

export default {
  values,
  selected,
  questions,
  reloading
}
